export const setOutlineStyle = (outlineStyle) => ({
    type: 'SET_OUTLINESTYLE',
    outlineStyle
});